import {ScrollLock} from '../utils/scroll-lock';

const header = document.querySelector('.j-header');
const burgerBtn = document.querySelector('.j-menu-toggle');
const navBlock = document.querySelector('.j-mobile-menu');
const breakpointLg = window.matchMedia('(min-width:1024px)');
const scrollLock = new ScrollLock();

const closeMenu = () => {
    burgerBtn.ariaPressed = 'false';
    navBlock.classList.remove('is-active');

    if (!header.classList.contains('header_status_scrolling')) {
        header.classList.remove('header_theme_blue');
        header.classList.add('header_status_animated');

        setTimeout(() => {
            header.classList.remove('header_status_animated');
        }, 400);
    }

    scrollLock.enableScrolling();
    burgerBtn.classList.remove('is-active');
    burgerBtn.classList.add('no-pointer');
    setTimeout(() => {
        burgerBtn.classList.remove('no-pointer');
    }, 1200);
};

const onEscPress = (evt) => {
    const isEscKey = evt.key === 'Escape' || evt.key === 'Esc';

    if (isEscKey && navBlock.classList.contains('is-open')) {
        evt.preventDefault();
        closeMenu();
        window.removeEventListener('keydown', onEscPress);
    }
};

const openMenu = () => {
    burgerBtn.ariaPressed = 'true';
    navBlock.classList.add('is-active');
    header.classList.add('header_theme_blue');
    scrollLock.disableScrolling();
    burgerBtn.classList.add('is-active', 'no-pointer');
    setTimeout(() => {
        burgerBtn.classList.remove('no-pointer');
    }, 1000);
    window.addEventListener('keydown', onEscPress);
};

const closeMenuOnResize = () => {
    if (navBlock.classList.contains('is-active')) {
        closeMenu();
    }
};

const initBurgerAction = () => {
    if (burgerBtn) {
        breakpointLg.addListener(closeMenuOnResize);
        burgerBtn.addEventListener('click', () => {
            if (burgerBtn.ariaPressed === 'true') {
                closeMenu();
            } else {
                openMenu();
            }
        });
    }
};

export {initBurgerAction, closeMenu};
